export default "__VITE_ASSET__DYg0tFQD__"